import React from "react";
import Component from "../../Components";
import "./NurseRequest.css";

const DeletedRequestDetailsPage = () => {
  return (
    <div className="mng-nurse-req">
      <Component.DeletedRequestDetails />
    </div>
  );
};

export default DeletedRequestDetailsPage;
